import React from 'react';
import { useSelector } from 'react-redux';
import { selectManualPieChartData } from '../../../../../../slices/teamStatsSlice';
import DistributionPieCard from './DistributionPieCard';

const Manual = () => {
  const pieChartData = useSelector(selectManualPieChartData)
  
  return (
    <DistributionPieCard title="Manual Investigations" pieChartData={pieChartData} />
  )
}

export default Manual
